/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import axios from '@src/plugins/http2'
import { getCsrf } from '@util/Cookie'

/**
 * @desc 创建企业条件判断
 */
export const getSemCreateCompanyCondition = () =>
  axios.get<GetSemCreateCompanyCondition>(
    'PLUSSVR',
    `/svr/v2/companies/conditions-check`
  )

export const getIsLogin = () => {
  // eslint-disable-next-line no-console
  return axios.post<GetIsLogin>('ACCOUNT', `/p/auth/check`, {
    csrfmiddlewaretoken: getCsrf(),
  })
}

export const logout = () =>
  axios.post('ACCOUNT', `/p/logout`, {
    csrfmiddlewaretoken: getCsrf(),
  })

// 获取媒体参数
export const getMediaParams = (data: MediaGetParams) =>
  axios.get('PLUS', `/ops/activity/api/v1/ads/reports/configs`, data)

// 回传媒体参数
export const mediaCallBack = (data: MediaCallParams) =>
  axios.post('PLUS', `/ops/activity/api/v1/ads/reports`, data)

// 获取所有关联账号
export const getRelatedUsers = () =>
  axios.get('ACCOUNT', `/api/v3/related_users`, {
    auth_types: 'email,phone',
  })
